var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_78992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 24C7.79145 24.0005 7.58808 23.9351 7.419 23.813L0.419 18.813C0.289531 18.7206 0.183979 18.5986 0.111106 18.4572C0.0382334 18.3158 0.000143776 18.1591 0 18L0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0C1.388 0 2.185 0.624 2.316 0.718L8.582 5.2C8.7117 5.29282 8.81731 5.41532 8.89003 5.55727C8.96274 5.69922 9.00045 5.85651 9 6.016V23C9.00019 23.1838 8.94971 23.3642 8.85409 23.5212C8.75847 23.6782 8.62142 23.8058 8.458 23.89C8.31602 23.9619 8.15916 23.9996 8 24Z",
    fill: "#9DB9CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13V19H14C14.2652 19 14.5196 18.8946 14.7071 18.7071C14.8946 18.5196 15 18.2652 15 18V13H11Z",
    fill: "#9DB9CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6.016V7H15V1C15 0.734784 14.8946 0.48043 14.7071 0.292893C14.5195 0.105357 14.2652 0 14 0L4.75098 0L9.75098 3.576C10.1373 3.85497 10.4519 4.22159 10.669 4.64574C10.8861 5.0699 10.9996 5.5395 11 6.016V6.016Z",
    fill: "#9DB9CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 10L18 5V9H11V11H18V15L24 10Z",
    fill: "#9DB9CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_78992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.7e577a3106276753fce35e8526a91af0.svg";
export { ForwardRef as ReactComponent };